<template>
  <div id="userInfo">
    <el-header>
      <top-Nav :headImgId="this.headImgId"></top-Nav>
    </el-header>
    <div class="monitor_wrap el-main">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span>个人中心</span><span class="arrow">></span><span>{{subTitle}}</span>
        </div>
      </div>
      <div class="main clearfix" :class="{Supervisory: userType == 0}" :style="{height:containerHeight+'px'}">
        <div class="main_left" v-show="userType != 0">
          <div class="person_info" @click="showListInfo(1)" :class="{is_focus: pageType == 1}">
            <i>
              <img src="../../assets/img/info_select.png" alt="" v-if="pageType == 1">
              <img src="../../assets/img/info_no_select.png" alt="" v-else>
            </i>
            个人信息
          </div>
          <div v-show="userType == 1 || userType == 2" class="message" @click="showListInfo(3)" :class="{is_focus:pageType == 3}" v-if="isAuth('common:interface')">
            <i>
              <img src="../../assets/img/message_select.png" alt="" v-if="pageType == 3">
              <img src="../../assets/img/message_no_select.png" alt="" v-else>
            </i>
            公告
          </div>
          <div v-show="userType == 1 || userType == 2" class="message" @click="showListInfo(2)" :class="{is_focus:pageType == 2}" v-if="isAuth('common:interface')">
            <i>
              <img src="../../assets/img/message_select.png" alt="" v-if="pageType == 2">
              <img src="../../assets/img/message_no_select.png" alt="" v-else>
            </i>
            消息
          </div>
        </div>
        <div class="main_right">
          <div class="person_info_list" v-if="showListPage">
            <div class="headImg_container" @click="alertUpLoadImg">
              <img src="../../assets/img/preview_url.png" alt="" v-if="previewIdUrl=='undefined'||!previewIdUrl||previewIdUrl=='null'">
              <img :src="previewIdUrl" alt="" v-else>
            </div>
            <el-form ref="form" :model="userInfo" label-width="80px" class="form_change">
              <el-form-item label="工号:">
                <el-input v-model="userInfo.userNumber" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item label="账号:">
                <el-input v-model="userInfo.loginName" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item label="密码:">
                <el-input v-model="userInfo.userpwd" :disabled="disabled" type="password"></el-input>
                <span style="padding-left: 16px;color: #198cff;cursor: pointer;font-size:13px;" @click="changePwd">修改</span>
              </el-form-item>
              <el-form-item label="手机号:">
                <el-input v-model="userInfo.userPhone" :disabled="disabled"></el-input>
                <span style="padding-left: 16px;color: #198cff;cursor: pointer;font-size:13px;" @click="changeMobile">修改</span>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <div v-if="pageType == 3" >
              <div class="message_list2" :style="{maxHeight:containerHeight2+'px'}" @scroll="scrollEvent2" v-if="noticeInfo.length!==0">
                  <!-- 公告 -->
                  <div v-for="(item,index) in noticeInfo" :key="index" :class="{grey_text:item.isRead==1}" class="message_list_info" @click="routerUrlbrod(item)" style="height:140px;">
                    <div class="message_icon"><img src="../../assets/img/message_info.png" alt=""></div>
                    <div class="message_info_data">
                      <div class="size_info">
                        <p class="info_type" style="margin-bottom:10px;">{{item.customerName}}:
                          <span>
                          公告
                          </span>
                        </p>
                        <div class="info_content">
                          <p><span v-if="item.enable" style="font-size:14px;color:#f55353;">[置顶]</span><span style="font-weight:bold;">{{item.title}}</span></p>
                          <p class="overText" v-html="item.photoId"></p>
                        </div>
                      </div>
                    </div>
                    <div class="message_info_date">{{item.publicDate}}</div>
                  </div>
              </div>
              <div v-else class="no_message">
                <div>
                  <img src="../../../static/img/Nomessage.png" alt="">
                  <p class="no_message_tip">暂无公告</p>
                </div>
              </div>
            </div>
            <div v-if="pageType == 2">
              <div class="message_list" :style="{maxHeight:containerHeight+'px'}" @scroll="scrollEvent" v-if="messageInfo.length!==0">
                  <!-- 通知和告警 -->
                  <div v-for="(item,index) in messageInfo" :key="index" :class="{warning_list:item.statusType==0}" class="message_list_info" @click="lookInfo(item)">
                    <div class="message_icon"><img src="../../assets/img/message_info.png" alt=""></div>
                    <div class="message_info_data">
                      <div class="size_info">
                        <p class="info_type">系统:
                          <span v-if="item.statusType==0">
                          <span v-if="item.monitoringType==1">电气</span>
                          <span v-else-if="item.monitoringType==2">水压</span>
                          <span v-else-if="item.monitoringType==3">液位</span>
                          <span v-else-if="item.monitoringType==4">可燃气</span>
                          <span v-else-if="item.monitoringType==5">烟感</span>
                          <span v-else-if="item.monitoringType==6">灭火器</span>
                          <span v-else-if="item.monitoringType==7">水浸</span>
                          <span v-else-if="item.monitoringType==8">用传</span>
                          <span v-else>--</span>
                          <span v-if="item.type==6">预警</span>
                          <span v-else>告警</span>
                        </span>
                          <span v-else-if="item.statusType==1">
                          <span v-if="item.monitoringType==1">电气</span>
                          <span v-else-if="item.monitoringType==2">水压</span>
                          <span v-else-if="item.monitoringType==3">液位</span>
                          <span v-else-if="item.monitoringType==4">可燃气</span>
                          <span v-else-if="item.monitoringType==5">烟感</span>
                          <span v-else-if="item.monitoringType==6">灭火器</span>
                          <span v-else-if="item.monitoringType==7">水浸</span>
                          <span v-else-if="item.monitoringType==8">用传</span>
                          <span v-else>--</span>离线
                        </span>
                          <span v-else-if="item.statusType==2">
                          <span v-if="item.monitoringType==1">电气</span>
                          <span v-else-if="item.monitoringType==2">水压</span>
                          <span v-else-if="item.monitoringType==3">液位</span>
                          <span v-else-if="item.monitoringType==4">可燃气</span>
                          <span v-else-if="item.monitoringType==5">烟感</span>
                          <span v-else-if="item.monitoringType==6">灭火器</span>
                          <span v-else-if="item.monitoringType==7">水浸</span>
                          <span v-else-if="item.monitoringType==8">用传</span>
                          <span v-else>--</span>故障
                        </span>
                          <span v-else-if="item.statusType==3">
                          通知
                        </span>
                        </p>
                        <div class="info_content" v-if="item.statusType==0" :class="{is_read:item.isRead==1}">
                          <p>编号为<span class="special_color">{{item.monitoringCode}}</span>的<span class="special_color">{{item.monitoringName}}</span>监测点发生<span v-if="item.type==6">预警</span> <span v-else>
                              <span v-if="item.content == 1 || item.content == 111">烟雾告警</span>
                              <span v-else-if="item.content == 963">防拆告警</span>
                              <span v-else-if="item.content == 986">高温告警</span>
                              <span v-else-if="item.content == 986">高温告警</span>
                              <span v-else>告警</span>
                          </span>，请及时处理!</p>
                          <p>该监测点位于<span class="special_color">{{item.detailAddress}}。</span></p>
                        </div>
                        <div class="info_content" v-else-if="item.statusType==1">
                          <p>编号为<span class="special_color">{{item.monitoringCode}}</span>的<span class="special_color">{{item.monitoringName}}</span>监测点发生离线，请及时处理!</p>
                          <p>该监测点位于<span class="special_color">{{item.detailAddress}}。</span></p>
                        </div>
                        <div class="info_content" v-else-if="item.statusType==2">
                          <p>编号为<span class="special_color">{{item.monitoringCode}}</span>的<span class="special_color">{{item.monitoringName}}</span>监测点发生故障，请及时处理!</p>
                          <p>该监测点位于<span class="special_color">{{item.detailAddress}}。</span></p>
                        </div>
                        <p class="info_content" v-else-if="item.statusType==3">
                          <span v-if="item.type==0">{{item.monitoringName}}设备的报警处理单已通过，再接再厉！</span>
                          <span v-else-if="item.type==1">{{item.monitoringName}}设备的报警处理单，请及时处理！</span>
                          <span v-else-if="item.type==2">{{item.monitoringName}}设备的报警处理单被退回，请及时处理！</span>
                          <!-- <span v-else-if="item.type==3">{{item.monitoringName}}设备的告警超时未处理，请及时处理！</span> -->
                          <span v-else-if="item.type==4">{{item.monitoringName}}设备的严重隐患上报处理单，请及时处理！</span>
                          <span v-else-if="item.type==5">{{item.monitoringName}}设备的严重隐患上报处理单已被处理，请及时处理！</span>
                        </p>
                        <p class="info_content" v-else-if="item.statusType==4">
                          <span v-if="item.type==4">{{item.monitoringName}}设备的告警超时未处理，请及时处理！</span>
                        </p>
                      </div>
                      <el-steps :active="item.dealStatus+1" align-center class="progress_type" v-if="item.statusType==0" :class="{completeColor:(item.dealStatus+1)==4}">
                        <el-step title="待处理" description="" icon="el-icon"></el-step>
                        <el-step title="处理中" description="" icon="el-icon"></el-step>
                        <el-step title="审核中" description="" icon="el-icon"></el-step>
                        <el-step title="已结束" description="" icon="el-icon"></el-step>
                      </el-steps>
                    </div>
                    <div class="message_info_date">{{item.createDate}}</div>
                  </div>
              </div>
              <div v-else class="no_message">
                <div>
                  <img src="../../../static/img/Nomessage.png" alt="">
                  <p class="no_message_tip">暂无消息</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-else v-show="!showListPage" class="no_message">
            <div>
              <img src="../../../static/img/Nomessage.png" alt="">
              <p class="no_message_tip">暂无消息</p>
            </div>
          </div> -->
        </div>
      </div>
      <!-- 预览公告 -->
      <el-dialog
        top='0'
        :showClose="false"
        :visible.sync="dialogVisible5"
        width="60%"
        height="calc(100%)"
        class="board">
        <div class="boardTitle"> 
          <div>{{noticeDetails.title}}</div>
          <div>发布时间：{{noticeDetails.publicDate}}</div>
        </div>
        <div class="boardTxt" v-html="noticeDetails.content"></div>
      </el-dialog>
      <!--修改密码弹框-->
      <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        :close-on-press-escape=false
        :close-on-click-modal=false
        width="650px"
      >
        <div class="password_form">
          <el-form :model="formPwd" label-width="80px" class="form_change" ref="formPwd" hide-required-asterisk>
            <el-form-item label="原密码:" prop="pwd1" :rules="{required: true}" :show-message="false" :class="{is_error:errorOldPwd,is_error1:isErrorType1}">
              <el-input type="password" v-model="formPwd.pwd1" placeholder="请输入原密码" v-on:input="hiddenPwd(1)" @blur="passWord"></el-input>
            </el-form-item>
            <el-form-item label="新密码:" prop="pwd2" :rules="{required: true}" :show-message="false" :class="{is_error:noSame,is_error1:isErrorType2}">
              <el-input type="password" v-model="formPwd.pwd2" placeholder="长度在6-12位之间的字母、数字或符号" v-on:input="hiddenPwd(2)" @blur="passWord"></el-input>
            </el-form-item>
            <el-form-item label="确认密码:" prop="pwd3" :rules="{required: true}" :show-message="false" :class="{is_error:noSame,is_error1:isErrorType3}">
              <el-input type="password" v-model="formPwd.pwd3" placeholder="请确认密码" v-on:input="hiddenPwd(3)" @blur="passWord"></el-input>
            </el-form-item>
          </el-form>
          <div class="form_tip" v-show="noSame">确认密码与新密码不一致!</div>
          <div class="form_tip" v-show="isErrorType">密码格式不正确!</div>
          <div class="form_tip" v-show="errorOldPwd">原密码错误!</div>
          <div class="form_tip" v-show="isSameOld">新旧密码不能一致!</div>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button style="min-width:80px;" @click="dialogVisible = false">取消</el-button>
    <el-button type="primary" style="min-width:80px;" @click="submitPwd('formPwd')">保存</el-button>
  </span>
      </el-dialog>
      <!--修改手机号弹框-->
      <el-dialog
        title="修改手机号"
        :visible.sync="dialogVisible1"
        :close-on-press-escape=false
        :close-on-click-modal=false
        width="650px">
        <div class="password_form">
          <el-form :model="formMobile" label-width="80px" class="form_change form_change1" ref="formMobile" hide-required-asterisk>
            <el-form-item label="手机号:" prop="mobile" :rules="{required: true}" :show-message="false" :class="{is_error:isErrorMobile}">
              <el-input v-model="formMobile.mobile" placeholder="长度不超过11个字数的数字" maxlength="11"></el-input>
            </el-form-item>
          </el-form>
          <div class="form_tip" v-show="isErrorMobile">手机号格式不正确!</div>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible1 = false">取消</el-button>
    <el-button type="primary" @click="changeUserInfo('formMobile')">保存</el-button>
  </span>
      </el-dialog>
      <!--编辑头像-->
      <el-dialog
        title="编辑头像"
        :visible.sync="dialogVisible2"
        :close-on-press-escape=false
        :close-on-click-modal=false
        @close="destoryCrop"
        width="650px"
      >
        <div style="display: flex">
          <div class="password_form1">
            <div class="img_preview" id="TCrop" v-show="showUploadBtn">
              <span class="upbag">上传图片</span>  
              <input type="file" accept="image/jpeg,image/png" id="file_img" @change="selectImg($event)" title="">
            </div>
            <div v-show="showUploadBtn" style="margin-top:10px;font-size:12px;color:#666666;text-align:center;">上传不超过2M的.jpg或.png格式图片</div>
            <div style="width: 100%;height: 100%" class="img_container_all" v-show="!showUploadBtn">
              <img :src="previewUrl" alt="" id="tailoringImg">
            </div>
          </div>
          <div class="preview_img">
            <div class="head_preview_tip">头像预览</div>
            <div class="container_img">
              <div class="nav_img_container same_container">
                <img src="../../assets/img/topUser.png" alt="">
              </div>
              <div>顶部导航</div>
              <div class="person_img_container same_container">
                <img src="../../assets/img/preview_url.png" alt="">
              </div>
              <div>个人中心</div>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
      <el-button class="re_choose" v-show="isNotFirstUpload"><span>重新选择 <input type="file" accept="image/jpeg,image/png" id="file_img1" @change="selectImg($event)" title=""></span></el-button>
    <el-button type="primary" @click="crop()">保存</el-button>
  </span>
      </el-dialog>
          <!-- 提示框(自动消失) -->
      <el-dialog title="提示" class="tips" :visible.sync="dialogTipsVisible" :modal="false" :closeOnClickModal="false">
          <span>{{tips}}</span>
          <span slot="footer" class="dialog-footer">
              <el-button style="min-width:80px" type="primary" @click="dialogTipsVisible = false">我知道了</el-button>
          </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
    import Cropper from 'cropperjs'
    import {ajaxFuncJson} from "../../api/ajax";
    import {uploadIp} from '../../api/ajax';
    import {SocketUrl} from '../../api/ajax'
    import topNav from '../../components/TopNav';
    export default {
        name: 'userInfo',
        components: {
          topNav
        },
        data () {
            return {
                pageType:1,
                noticeDetails:{},
                noticeInfo:[],
                dialogVisible5:false,
                msg: '个人中心',
                userType:sessionStorage.getItem("userType"),
                activeName: 'second',
                leftNavParams:{
                  isShowLeftIcon:false,
                  isShowLeftNav:true,
                },
              tips:'',
              subTitle:'个人信息',
              disabled:true,
              noSame:false,
              isSameOld:false,
              isErrorType:false,  //错误格式
              errorOldPwd:false,  //显示错误密码
              isErrorType1:false,
              isErrorType2:false,
              isErrorType3:false,
              isErrorMobile:false,
              formMobile:{
                  mobile:''
              },
              userInfo:{
                userName:'',
                userNumber:'',
                loginName:'',
                userpwd:'',
                userPhone:'',
                head: '',
              },
              formPwd:{
                pwd1:'',
                pwd2:'',
                pwd3:'',
              },
              saveformPwd:{ //保存
                pwd1:'',
                pwd2:'',
                pwd3:'',
              },
              dialogTipsVisible:false,
              dialogVisible:false,
              dialogVisible1:false,
              dialogVisible2:false,
              indexNum1:0,       //旧密码
              indexValue1:'',
              indexNum2:0,      //新密码
              indexValue2:'',
              indexNum3:0,      //确认密码
              indexValue3:'',
              allStrPwd1:'',    //总的旧密码
              allStrPwd2:'',    //总的新密码
              allStrPwd3:'',    //总的确认密码
              previewUrl:'',    //预览图片
              showUploadBtn:true, //显示图片
              headerImage:'',
              containerHeight:'',    //消息容器高度
              containerHeight2:'',    //公告容器高度
              showListPage:true,
              fileName:'', //文件名
              fileId:'',    //文件id
              userId:'',
              previewIdUrl:'',    //接口预览图片
              isNotFirstUpload:false,
              headImgId:'',
              messageInfo:[],
              messageParams:{
                currentPage:1,
                pageSize:10,
              },
              messageParams2:{
                currPage:1,
                pageSize:10,
              },
              isKaiGuan:true,
              isKaiGuan2:true,
              websocket:null,
              num:0,
              windowResize:null,

              socketNoticClose :1,//我关闭的
              lockReconnect: false,//是否真正建立连接
              timeoutnum: null,//断开 重连倒计时
              timeoutnumSucc: null,//断开 重连倒计时
              timeoutnumSucc1: null,//断开 重连倒计时
            }
        },
        created() {
          this.showListPage = this.$route.query.showListPage
          const params = JSON.parse(JSON.stringify(this.leftNavParams));
          if(!localStorage.getItem('avatar')||localStorage.getItem('avatar')=='undefined'||localStorage.getItem('avatar')=='null'){
            this.previewIdUrl=localStorage.getItem('avatar');
          }else {
            this.previewIdUrl=uploadIp()+'/file/filePreview/'+localStorage.getItem('avatar');
          }
          if(localStorage.getItem('userid')){
            this.userId=localStorage.getItem('userid');
          }
          this.$emit('getItem', params); //是否显示左侧新增建筑图标 //是否显示左侧导航
          if (sessionStorage.getItem('showListPage')) {
              this.showListInfo(1);
            this.getUserInfoData();
          } 
          if(sessionStorage.getItem('showListPage')=='false') {
            this.showListInfo(2);
          }
        },
        computed:{
          msgUrl(){
            return this.$route.query.msg;
          }

        },
        watch:{
          msgUrl(val){
            if(val==='head'){
              this.showListPage=true;
              this.subTitle='个人信息';
               this.showListInfo(1);
              this.getUserInfoData();
            }else {
              this.showListInfo(2);
            }
          }
        },
        methods:{
          //获取个人用户信息
          getUserInfoData(){
            let params={
              id:this.userId,
            };
            ajaxFuncJson('/users/personalCen',params).then(res=>{
              if(res.data.status==200){
                if(res.data.data){
                  this.userInfo.userName=res.data.data.userName;
                  this.userInfo.userNumber=res.data.data.userNumber;
                  this.userInfo.loginName=res.data.data.loginName;
                  this.userInfo.userPhone=res.data.data.userPhone;
                  this.userInfo.head=res.data.data.avatar;
                  this.userInfo.userpwd=res.data.data.userpwd;
                }
              }
            })
          },
          //销毁crop
          destoryCrop(){
            this.isNotFirstUpload=false;
            this.cropper.destroy();
          },
          // 效验原密码
          checkOldPwd(){
            let params={
              userId:this.userId,
              password:this.allStrPwd1,
            };
            ajaxFuncJson('/users/checkpassword',params).then(res=>{
              if(res.data.status==200){
                  if(this.allStrPwd2==this.allStrPwd3){
                    this.submitPwdAjax();
                  }else {
                    this.noSame=true;
                    this.formPwd.pwd2='';
                    this.formPwd.pwd3='';
                    this.indexNum2=0;
                    this.indexNum3=0;
                    this.indexValue2=0;
                    this.indexValue3=0;
                  }
              }else {
                this.errorOldPwd=true;
                this.formPwd.pwd1='';
                this.indexNum1=0;
                this.indexValue1='';
              }
            })
          },
          //提交密码
          submitPwdAjax(){
            let param={
              newpassword1:this.allStrPwd2,
              newpassword2:this.allStrPwd3,
              userId:this.userId,
            };
            ajaxFuncJson('/users/updatepassword',param).then(res=>{
              if(res.data.status==200){
                this.dialogVisible=false;
                this.$alert('修改成功', '提示', {
                  confirmButtonText: '我知道了',
                  callback: action => {
                    this.$router.push({ path: "/" });
                  }
                });
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error',
                })
              }
            })
          },
          //左侧tab切换
          showListInfo(type){
            this.pageType = type;
            this.messageInfo = [];
            this.noticeInfo = [];
            if(type===1){
              this.showListPage=true;
              this.subTitle='个人信息';
              this.getUserInfoData();
            }else if(type===2){
              this.showListPage=false;
              this.subTitle='消息';
              this.containerHeight=$(document).height()-(61+$('.mainHead').outerHeight()+30);
              this.getMessageInfoAjax(1);
              this.initWebSocket();
            }else if(type===3){
              this.showListPage=false;
              this.subTitle='公告';
              this.containerHeight2=$(document).height()-(61+$('.mainHead').outerHeight()+30);
              this.getBrodList(1);
            }
          },
          //滚动条在Y轴上的滚动距离
          getScrollTop() {
            var scrollTop = 0,
              bodyScrollTop = 0;
            if (document.getElementsByClassName('message_list')[0]) {
              bodyScrollTop = document.getElementsByClassName('message_list')[0].scrollTop;
            }
            scrollTop =bodyScrollTop;
            return scrollTop;
          },
          //文档的总高度
          getScrollHeight() {
            var scrollHeight = 0,
              bodyScrollHeight = 0;
            if (document.getElementsByClassName('message_list')[0]) {
              bodyScrollHeight = document.getElementsByClassName('message_list')[0].scrollHeight;
            }
            scrollHeight = bodyScrollHeight;
            return scrollHeight;
          },
          //文档视口的高度
          getWindowHeight() {
            var windowHeight = 0;
            windowHeight = document.getElementsByClassName('message_list')[0].clientHeight;
            return windowHeight;
          },
          // 公告
          //滚动条在Y轴上的滚动距离
          getScrollTop2() {
            var scrollTop2 = 0,
              bodyScrollTop2 = 0;
            if (document.getElementsByClassName('message_list2')[0]) {
              bodyScrollTop2 = document.getElementsByClassName('message_list2')[0].scrollTop;
            }
            scrollTop2 =bodyScrollTop2;
            return scrollTop2;
          },
          //文档的总高度
          getScrollHeight2() {
            var scrollHeight2 = 0,
              bodyScrollHeight2 = 0;
            if (document.getElementsByClassName('message_list2')[0]) {
              bodyScrollHeight2 = document.getElementsByClassName('message_list2')[0].scrollHeight;
            }
            scrollHeight2 = bodyScrollHeight2;
            return scrollHeight2;
          },
          //文档视口的高度
          getWindowHeight2() {
            var windowHeight2 = 0;
            windowHeight2 = document.getElementsByClassName('message_list2')[0].clientHeight;
            return windowHeight2;
          },
          routerUrlbrod(item){ //五期公告详情
              let params={   //已读接口
                noticeId:item.id,
              }      
              ajaxFuncJson('/alarmNoticeRecord/readNotice',params).then(res=>{
                let Data = res.data.data
                    item.isRead=1
              }); 
            ajaxFuncJson('/notice/findNoticeById',{id:item.id}).then(res=>{ //获取详情接口
              if(res.data.status==200){
                this.noticeDetails = res.data.data;
              }
            }); 
             this.dialogVisible5 = true;
          },
          lookInfo(item){
            sessionStorage.setItem('saveId',item.monitoringId);
            if(item.statusType==3){
              if(item.type==0){
                this.$router.push({path:'/content/searchForm',query:{searchUrl:'3-1',id:item.alarmDealRecordId,deviceType:item.monitoringType}});
              }else if(item.type==1){
                this.$router.push({path:'/content/searchForm',query:{searchUrl:'2-1',id:item.alarmDealRecordId,deviceType:item.monitoringType}});
              }else if(item.type==2){
                sessionStorage.setItem('dealStatus',1);
                this.$router.push({path:'/content/searchForm',query:{id:item.alarmDealRecordId,deviceType:item.monitoringType,type:'warnData'}});
              }else if(item.type == 3){ //超时告警
                sessionStorage.setItem('dealStatus',item.dealStatus);
                sessionStorage.setItem('saveId',item.monitoringId);
                 this.$router.push({path:'/content/monitorDetails'});
              }else if(item.type == 4){ //退回重新整改
                sessionStorage.setItem('dealStatus',8);
                this.$router.push({path:'/content/searchForm',query:{searchUrl:'2-1',id:item.alarmDealRecordId,deviceType:item.monitoringType}});
              }else if(item.type == 5){ //已协调资源
                this.$router.push({path:'/content/searchForm',query:{searchUrl:'2-1',id:item.alarmDealRecordId,deviceType:item.monitoringType}});
              }
            }else {
              this.$router.push({path:'/content/monitorDetails'});
            }
          },
          scrollEvent(){
            this.menu();
          },
          scrollEvent2(){
            this.menu2();
          },
          menu() {
            if(this.isKaiGuan){
              let scroll = this.getScrollTop() + this.getWindowHeight() - this.getScrollHeight();
              if (scroll > -60) {
                this.messageParams.currentPage++;
                this.getMessageInfoAjax();
                this.isKaiGuan=false;
              }
            }
          },
          menu2() {
            if(this.isKaiGuan2){
              let scroll2 = this.getScrollTop2() + this.getWindowHeight2() - this.getScrollHeight2();
              if (scroll2 > -60) {
                this.messageParams2.currPage++;
                this.getBrodList();
                this.isKaiGuan2=false;
              }
            }
          },
          add0(m){
            return m<10?'0'+m:m
          },
          format(times) {
            var time = new Date(times);
            var y = time.getFullYear();
            var m = time.getMonth()+1;
            var d = time.getDate();
            var h = time.getHours();
            var mm = time.getMinutes();
            var s = time.getSeconds();
            return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
          },
          getBrodList(type){ //五期公告
              if(type===1){
                this.messageParams2.currPage=1;
              }
              ajaxFuncJson('/notice/getNoticeForUser',this.messageParams2).then(res=>{
                if(res.data.status==200 && res.data.data.length>0){
                  if(res.data.data.length!=10){
                    this.isKaiGuan2=false;
                  }else {
                    this.isKaiGuan2=true;
                  }
                  this.noticeInfo = this.noticeInfo.concat(res.data.data);
                  this.noticeInfo.forEach((list,index)=>{
                    list.publicDate=this.format(list.publicDate);
                    list.content = ((list.content).toString()).replace(/<img[^>]*>/g, "<span style='color:#198cff;'>[图片]</span>");
                    list.photoId = ((list.photoId).toString()).replace(/\[图片\]/g, "<span class='span' style='color:#199aff !important;'>[图片]</span>");
                  })
                }
              });
          },
          getMessageInfoAjax(type){
              if(type===1){
                this.messageParams.currentPage=1;
              }
              ajaxFuncJson('/alarmNoticeRecord/getNoticList',this.messageParams).then(res=>{
                if(res.status==200){
                  if(res.data.data.length!=10){
                    this.isKaiGuan=false;
                  }else {
                    this.isKaiGuan=true;
                  }
                  this.messageInfo=this.messageInfo.concat(res.data.data);
                  this.messageInfo.forEach((list,index)=>{
                    if(list.recordTime){
                      list.createDate=this.format(list.recordTime);
                    }else{
                      list.createDate=this.format(list.createDate);
                    }
                  })
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error',
                  })
                }
              });
          },
           // 心跳
          timeoutnumSuccF(){
             var that = this;
              that.timeoutnumSucc && clearTimeout(that.timeoutnumSucc);
              that.timeoutnumSucc1 && clearTimeout(that.timeoutnumSucc1);
              that.timeoutnumSucc = setTimeout(function () {
              
                if (that.websocket.readyState===1) {
                  that.websocket.send("monitorReconnection");
                }else{
                    //do something
                }
                that.timeoutnumSucc1 = setTimeout(function () {
                  that.websocket.close();
                },10000);
              },1200000);
          },
          initWebSocket(){
            let token = sessionStorage.getItem('token')
            const url=SocketUrl()+'/alarmNoticeRecord/getNoticeList?token='+token;
            if(token){
              this.websocket=new WebSocket(url);
              this.websocket.onopen=this.websocketonopen;
              this.websocket.onerror=this.websocketonerror;
              this.websocket.onmessage=this.websocketonmessage;
              this.websocket.onclose=this.websocketclose;
            }
          },
          websocketonopen(){
            // console.log('连上了');
            this.socketNoticClose = 1;//连接成功他就等于1
            this.timeoutnumSuccF()
          },
          websocketonerror(){
            // console.log('发生错误');

            
          },
          websocketonmessage(event){
            if(this.$route.path==='/userInfo'){
                if(event.data =="connectSuccess"){
                  this.timeoutnumSuccF()
                  }else if(event.data == 'HAVE_NEW_GROUP'){ //公告
                    this.noticeInfo = []; //清空之前的
                    this.getBrodList(1);
                    this.messageInfo.currentPage=1;
                    this.getMessageInfoAjax(1);
                  }else{
                  this.getBrodList(1);
            　　　 this.messageInfo.currentPage=1;
                  // this.messageInfo=JSON.parse(event.data); 2021.8.6
                   this.getMessageInfoAjax(1);
                }
            }
          },
          websocketclose(){
              if(this.socketNoticClose == 2)return;
              var that = this;
              if(that.lockReconnect) {
                  return;
              };
              that.lockReconnect = true;
              //没连接上会一直重连，设置延迟避免请求过多
              that.timeoutnum && clearTimeout(that.timeoutnum);
              that.timeoutnum = setTimeout(function () {
                  //新连接
                  that.initWebSocket();//连接websocket  
                  that.lockReconnect = false;
              },10000);
          },
          //弹出上传图片框
          alertUpLoadImg(){
            this.dialogVisible2=true;
            this.showUploadBtn=true;
            this.$nextTick(()=>{
              var image = document.getElementById('tailoringImg');
              this.cropper = new Cropper(image, {
                aspectRatio: 1,
                viewMode: 1,
                background:false,
                mouseWheelZoom:true,
                zoomable:true,
                preview:'.same_container',
                ready: function () {

                },
                crop:function (data) {

                }
              });
            });
          },
          //弹出密码弹框
          changePwd(){
              this.noSame=false;
              this.isSameOld=false;
              this.isErrorType=false;  //错误格式
              this.errorOldPwd=false;    //显示错误密码
              this.isErrorType1=false;
              this.isErrorType2=false;
              this.isErrorType3=false;
              this.formPwd={
                pwd1:'',
                pwd2:'',
                pwd3:'',
              };
            this.indexNum1=0;
            this.indexValue1='';
            this.indexNum2=0;
            this.indexValue2='';
            this.indexNum3=0;
            this.indexValue3='';
            this.dialogVisible=true;
            this.$nextTick(()=>{
              this.$refs.formPwd.resetFields();
            })
          },
          //弹出手机弹框
          changeMobile(){
            this.isErrorMobile=false;
            this.formMobile={
              mobile:''
            };
            this.dialogVisible1=true;
            this.$nextTick(()=>{
              this.$refs.formMobile.resetFields();
            })
          },
          selectImg(files){
            let file=files.target,_this=this;
            this.fileName=file.files[0].name;
            if (!file.files || !file.files[0]){
              return;
            }else {
              if(this.fileName.indexOf('jpg')===-1&&this.fileName.indexOf('png')===-1) {
                this.tips = "请上传JPG，PNG格式图片！";
                this.dialogTipsVisible = true;
                document.getElementById('file_img').value='';
                document.getElementById('file_img1').value='';
                let that = this;
                let test1 = setTimeout(function(){ //提示框
                    that.dialogTipsVisible = false;
                    clearTimeout(test1);
                },5000);
                return;
              }
              if(file.files[0].size / 1024 / 1024 > 2){
                 this.tips = "头像大小不能超过2MB，请重新上传！";
                  this.dialogTipsVisible = true;
                  document.getElementById('file_img').value='';
                  document.getElementById('file_img1').value='';
                  let that = this;
                  let test1 = setTimeout(function(){ //提示框
                      that.dialogTipsVisible = false;
                      clearTimeout(test1);
                  },5000)
                return;
              }
            }
            var reader = new FileReader();
            reader.onload = function (evt) {
              var replaceSrc = evt.target.result;
              _this.showUploadBtn=false;
              //更换cropper的图片
              _this.previewUrl=replaceSrc;
              _this.isNotFirstUpload=true;

              //每次替换图片要重新得到新的url
              if(_this.cropper){
                _this.cropper.replace(_this.previewUrl,false);
              }
            };
            reader.readAsDataURL(file.files[0]);
          },
          //上传图片
          upLoadAjax(){
            let params={
              file:this.headerImage,
              filename:this.fileName,
            };
            ajaxFuncJson('/file/uploadBase64',params).then(res=>{
              if(res.data.status==200){
                  this.fileId=res.data.fileId;
                  this.previewIdUrl=uploadIp()+'/file/filePreview/'+this.fileId;
                  this.changeUserInfo();
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error'
                })
              }
            })
          },

          //修改用户的信息
          changeUserInfo(formMobile){
            if(formMobile){
              this.isErrorMobile=false;
              this.$refs[formMobile].validate((valid) => {
                if (valid) {
                  let reg=/^[1][3,4,5,7,8][0-9]{9}$/;
                  if(reg.test(this.formMobile.mobile)){
                    this.userInfo.userPhone=this.formMobile.mobile;
                    this.changeInfoAjax(1);
                  }else {
                    this.formMobile.mobile='';
                    this.isErrorMobile=true;
                  }
                } else {
                  return false;
                }
              });
            }else {
              this.userInfo.head=this.fileId;
              this.changeInfoAjax();
            }
          },
          // 修改信息接口
          changeInfoAjax(params){
              this.userInfo.id=this.userId;    //this.userId
              ajaxFuncJson('/users/updatepersonal',this.userInfo).then(res=>{
                if(res.data.status==200){
                  localStorage.setItem('avatar',this.userInfo.head);
                  this.headImgId=uploadIp()+'/file/filePreview/'+this.userInfo.head;
                  this.getUserInfoData();
                  if(params===1){
                    this.dialogVisible1=false;
                  }else {
                    this.cropper.destroy();
                    this.dialogVisible2=false;
                  }
                }else {
                  this.$message({
                    message:res.data.msg,
                    type:'error',
                  })
                }
              });
          },
          //截取
          crop () {
            var croppedCanvas;
            var roundedCanvas;
            croppedCanvas = this.cropper.getCroppedCanvas();
            if(croppedCanvas){
              roundedCanvas = this.getRoundedCanvas(croppedCanvas);
              this.headerImage = roundedCanvas.toDataURL();   //头像路径
              this.upLoadAjax();
            }
          },
          getRoundedCanvas (sourceCanvas) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var width = sourceCanvas.width;
            var height = sourceCanvas.height;
            canvas.width = width;
            canvas.height = height;
            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();
            return canvas;
          },
          hiddenPwd(pwdIndex){
            let indexNum='indexNum'+pwdIndex,
                indexValue='indexValue'+pwdIndex,
                inputPwd='pwd'+pwdIndex;
            this.showLastCode(this.formPwd[inputPwd],indexNum,indexValue,inputPwd);
          },
          validatePwd(val){
            let reg=/^[a-zA-Z0-9\W_]{6,12}$/;
            return reg.test(val)
          },
          //密码输入格式   val 输入的内容  pwdIndex初始的下标   pwdValue初始的字符 inputPwd输入的密码字段
          showLastCode(val,pwdIndex,pwdValue,inputPwd){
            // val = val.slice(0,val.length-1)
            // val = val.replace(/\W/g,'*') +val.substr(0,1);
            if(val.length>1){
              if(this[pwdValue].length>=val.length){
                this[pwdIndex] =val.length-1;
                this[pwdValue] = this[pwdValue].substr(0, this[pwdIndex]+1);
                this.formPwd[inputPwd]=val.substr(0,this[pwdIndex])+this[pwdValue].substr(this[pwdIndex],this[pwdIndex]+1);
                this[pwdValue] = this[pwdValue].substr(0, this[pwdIndex]);
              }else {
                var userPwd = val.substring(this[pwdIndex]++,val.length-1);
                this[pwdValue]=this[pwdValue]+userPwd;
                var reg = "*";
                this.formPwd[inputPwd]=this.formPwd[inputPwd].replace(userPwd,reg);
              }
            }else if(val.length===1){
              if(this[pwdValue]!=''){
                this.formPwd[inputPwd]=this[pwdValue].substr(0,1);
              }
            }else {
              this[pwdValue]='';
              this[pwdIndex]=0;
            }
          },
          passWord(val){
            if(this.formPwd.pwd1 != ''){
                if(this.formPwd.pwd1.substr(-1) !='*'){
                  this.saveformPwd.pwd1 = this.formPwd.pwd1;
                }
                //  let re = this.formPwd.pwd1;
                //  let rearray = re.split('');
                //  rearray.pop();
                //  let restr= rearray.join('');
                //  this.formPwd.pwd1 = restr + '*';  

                //  this.formPwd.pwd1 = re.replace(/\d+/g,'*'); 
                //  this.formPwd.pwd1 = this.formPwd.pwd1.replace(/[^*]/g,'*'); 
             }
             if(this.formPwd.pwd2 != ''){
               if(this.formPwd.pwd2.substr(-1) !='*'){
                 this.saveformPwd.pwd2 = this.formPwd.pwd2;
               }
                //  let re2 = this.formPwd.pwd2;
                //  let rearray2 = re2.split('');
                //  rearray2.pop();
                //  let restr2 = rearray2.join('');
                //  this.formPwd.pwd2 = restr2 + '*'; 

                //  this.formPwd.pwd2 = re2.replace(/\d+/g,'*');
                //  this.formPwd.pwd2 = this.formPwd.pwd2.replace(/[^*]/g,'*'); 
             }
             if(this.formPwd.pwd3 != ''){
               if(this.formPwd.pwd3.substr(-1) !='*'){
                 this.saveformPwd.pwd3 = this.formPwd.pwd3;
               }
                //  let re3 = this.formPwd.pwd3;
                //  let rearray3 = re3.split('');
                //  rearray3.pop();
                //  let restr3 = rearray3.join('');
                //  this.formPwd.pwd3 = restr3 + '*';

                  // this.formPwd.pwd3 = re3.replace(/\d+/g,'*');
                  // this.formPwd.pwd3 = this.formPwd.pwd3.replace(/[^*]/g,'*'); 
             }
          },
          //修改密码确定
          submitPwd(formPwd){
            this.$refs[formPwd].validate((valid) => {
              if (valid) {
                this.noSame=false;
                this.isSameOld=false;
                this.isErrorType=false;  //错误格式
                this.errorOldPwd=false;    //显示错误密码
                this.isErrorType1=false;
                this.isErrorType2=false;
                this.isErrorType3=false;
                // this.allStrPwd1=this.indexValue1+this.formPwd.pwd1.substr(-1);  //原密码
                // this.allStrPwd2=this.indexValue2+this.formPwd.pwd2.substr(-1);
                // this.allStrPwd3=this.indexValue3+this.formPwd.pwd3.substr(-1);
                this.allStrPwd1=this.indexValue1+this.saveformPwd.pwd1.substr(-1);  //原密码
                this.allStrPwd2=this.indexValue2+this.saveformPwd.pwd2.substr(-1);
                this.allStrPwd3=this.indexValue3+this.saveformPwd.pwd3.substr(-1);
                     //效验原密码正确  新密码符合输入格式  新密码与确认密码相同  新旧密码不一致
                  if(this.validatePwd(this.allStrPwd1)){
                    if(this.validatePwd(this.allStrPwd2)){
                      if(this.validatePwd(this.allStrPwd3)){
                        if(this.allStrPwd2!=this.allStrPwd1){
                          this.checkOldPwd();
                        }else {
                          this.isSameOld=true;
                          this.formPwd={
                            pwd11:'',
                            pwd2:'',
                            pwd3:'',
                          };
                          this.indexNum1=0;
                          this.indexValue1='';
                          this.indexNum2=0;
                          this.indexValue2='';
                          this.indexNum3=0;
                          this.indexValue3='';
                          console.log('新旧密码一致')
                        }
                      }else {
                        this.isErrorType=true;
                        this.isErrorType3=true;
                        this.formPwd.pwd3='';
                        this.indexNum3=0;
                        this.indexValue3='';
                        console.log('确定密码格式不正确');
                      }
                    }else {
                      console.log('新密码格式不正确');
                      this.isErrorType=true;
                      this.isErrorType2=true;
                      this.formPwd.pwd2='';
                      this.indexNum2=0;
                      this.indexValue2='';
                    }
                  }else {
                    this.isErrorType=true;
                    this.isErrorType1=true;
                    this.formPwd.pwd1='';
                    this.indexValue1='';
                    this.indexNum1=0;
                    console.log('格式错误');
                  }
              } else {
                return false;
              }
            });
          },
        },
        mounted() {
            let that = this;
            that.windowResize= function () {
             that.containerHeight=$(document).height()-(61+$('.mainHead').outerHeight()+30);
             that.containerHeight2=$(document).height()-(61+$('.mainHead').outerHeight()+30);
            };
            that.windowResize();
            window.addEventListener('resize',that.windowResize);
        },
        destroyed () {
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        },
    }
</script>
<style src="../../assets/css/cropper.min.css"></style>
<style lang="scss" scoped>
  @import "../../assets/css/mixin.scss";
  @import "../../assets/css/style.scss";
  .grey_text .overText{
    color: #999999 !important;
    span,p,strong{
      color: #999999 !important;
    }
  }
  #userInfo{
    .el-main{
      width: 100%;
      margin: 10px 0;
      overflow: hidden;
    }
  }
  .mainHead{
    margin: 0 20px;
  }
    .main{
      margin-top: 10px;
      margin-right: 20px;
      margin-left: 20px;
      height: 100%;
      background: #fff;
      display: flex;
      border: 1px solid #efefef;
      .main_left{
        width: 196px;
        border: 1px solid #efefef;
        height: 100%;
        div{
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #efefef;
          padding-left:20px;
          position: relative;
          cursor: pointer;
          color: #282828;
          font-size: 14px;
        }
        .person_info{
          i{
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-right: 6px;
            position: relative;
            top:3px;
          }
        }
        .message{
          i{
            display: inline-block;
            width: 16px;
            height: 16px;
            margin-right: 6px;
            position: relative;
            top:3px;
          }
        }
        .is_focus{
          color: #198cff!important;
        }
        div:hover::after{
          background: url("../../assets/img/move_arrow.png");
          position: absolute;
          content: '';
          width: 12px;
          height: 12px;
          right: 12px;
          top:14px;
          display: block;
        }
        div:after{
          position: absolute;
          content: '';
          width: 12px;
          height: 12px;
          background: url("../../assets/img/default_arrow.png");
          right: 12px;
          top:14px;
          display: block;
        }
        .is_focus:after{
          background: url("../../assets/img/move_arrow.png");
        }
      }
      .main_right{
        .person_info_list{
          padding-top: 40px;
          padding-left: 120px;
          .headImg_container{
            width: 80px;
            height: 80px;
            border-radius: 50%;
            margin-bottom:20px;
            margin-left: 190px;
            cursor: pointer;
            border:1px solid #efefef;
            img{
              width: 100%;
              height: auto;
            }
          }
        }
        .no_message{
          color: #666;
          font-size: 14px;
          background: #fff;
          position: absolute;
          left: 50%;
          top:50%;
          transform: translate(-50%,-50%);
          .no_message_tip{
            padding-top: 10px;
            text-align: center;
          }
        }
        .message_list2{
          margin-left: 40px;
          border: 1px dotted #a9a9a9;
          border-bottom: 2px dotted #a9a9a9;
          overflow-y: auto;
          .message_list_info{
            height: 100px;
            width: 1070px;
            border-top: 1px dotted #a9a9a9;
            cursor: pointer;
            padding: 0 40px 0 45px;
            display: flex;
            position: relative;
            align-items: center;
            .message_icon{
              width: 40px;
              height: 40px;
              border-radius: 50%;
            }
            .message_info_data{
              color: #282828;
              font-size: 13px;
              padding-left: 30px;
              .size_info{
                line-height: 1.8;
                .is_read{
                  color: #999;
                }
                .special_color{
                  color: #fb8c00;
                }
              }
            }
            .message_info_date{
              position: absolute;
              right: 40px;
              top:20px;
              font-size: 14px;
            }
          }
          .warning_list{
            height: 140px;
          }
        }
        .message_list{
          margin-left: 40px;
          border: 1px dotted #a9a9a9;
          border-bottom: 2px dotted #a9a9a9;
          overflow-y: auto;
          .message_list_info{
            height: 100px;
            width: 1070px;
            border-top: 1px dotted #a9a9a9;
            cursor: pointer;
            padding: 0 40px 0 45px;
            display: flex;
            position: relative;
            align-items: center;
            .message_icon{
              width: 40px;
              height: 40px;
              border-radius: 50%;
            }
            .message_info_data{
              color: #282828;
              font-size: 13px;
              padding-left: 30px;
              .size_info{
                line-height: 1.8;
                .is_read{
                  color: #999;
                }
                .special_color{
                  color: #fb8c00;
                }
              }
            }
            .message_info_date{
              position: absolute;
              right: 40px;
              top:20px;
              font-size: 14px;
            }
          }
          .warning_list{
            height: 140px;
          }
        }
      }
    }
    .form_change .el-input{
      width: 300px;
    }
  .password_form{
    border: 1px solid #e0e0e0;
    height: 368px;
    .form_change{
      width: 390px;
      margin: 114px auto 0;
    }
    .form_change1{
      margin: 167px auto 0;
    }
    .form_tip{
      color: #f55353;
      font-size:13px;
      text-align: center;
      padding-top: 20px;
    }
  }
  .password_form1{
    border: 1px solid #e0e0e0;
    border-radius: 2px;
    height: 368px;
    width: 420px;
    .img_preview{
      color: #fff;
      width: 90px;
      height: 30px;
      background: #198cff;
      position: relative;
      text-align: center;
      line-height: 30px;
      margin: 169px auto 0;
      border-radius: 3px;
      &:hover{
            background-color: #3399ff;
      }
      #file_img{
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
        font-size: 0;
      }
    }
  }
  .preview_img{
    height: 368px;
    width: 180px;
    border: 1px solid #efefef;
    border-radius: 2px;
    font-size: 12px;
    margin-left: 10px;
    color: #666;
    text-align: center;
    .head_preview_tip{
      padding-top: 10px;
      padding-left: 10px;
      font-size: 13px;
      color: #282828;
      text-align: left;
    }
    .container_img{
      padding-top: 52px;
      .nav_img_container{
        width: 38px;
        height: 38px;
        border:1px solid #efefef;
        border-radius: 50%;
        margin: 0 auto 10px;
        overflow: hidden;
        img{
          width: 100%;
          height: auto;
        }
      }
      .person_img_container{
        width: 80px;
        height: 80px;
        border:1px solid #efefef;
        border-radius: 50%;
        margin: 40px auto 10px;
        overflow: hidden;

        img{
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .img_container_all img{
    width: 100%;
    height: auto;
  }
  .re_choose{
    position: relative;
  }
  .re_choose #file_img1{
    opacity: 0;
    left: 0;
    top: 0;
    position: absolute;
    height: 30px;
    width: 90px;
    cursor: pointer;
    font-size: 0;
  }
  .progress_type{
    width: 370px;
    margin-left: -30px;
  }
</style>




// WEBPACK FOOTER //
// src/page/userInfo/index.vue